import { gql } from "lib/apolloClient";
import {
  questionFragments,
  organizationResourceQuestionFragment,
  questionDetailsV2Fragment,
  associatedEntityTypesFragments,
} from "QuestionBank/modules/QuestionBankFragment";
import {
  staffFragment,
  plannerElementNodeFragment,
} from "modules/CommonFragments";

/**
 * @deprecated use getQuestionLibraryFeedQueryV2 instead
 * This is kept for backward compatibility
 * It will be removed in future versions
 */
export const getQuestionLibraryFeedQuery = gql`
  query getQuestionLibraryFeed(
    $orgResourceFilters: OrganizationResourceFilter
    $first: Int
    $after: String
    $orgId: ID!
    $fetchConversations: Boolean!
    $orderBy: ORDER_BY_ENUM
  ) {
    node(type: ORGANIZATION, id: $orgId) {
      id
      ... on Organization {
        id
        organizationResourcesV2(
          filters: $orgResourceFilters
          first: $first
          after: $after
          orderBy: $orderBy
        ) {
          resourceTypeBasedCount {
            totalCount
            questionStatusWiseCount {
              status
              count
            }
          }
          pageInfo {
            hasNextPage
            endCursor
          }
          edges {
            node {
              id
              label
              resourceType
              type
              state
              item {
                ...questionFeedDetailsItem
              }
              childrenV2(
                first: null
                orderBy: DISPLAY_SEQUENCE
                orderByDirection: ASC
              ) {
                resourceTypeBasedCount {
                  totalCount
                }
                edges {
                  node {
                    id
                    label
                    resourceType
                    type
                    state
                    item {
                      ...subQuestionFeedDetailsItem
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${questionFragments.questionLibraryFeedDetails}
  ${questionFragments.subQuestionFeedDetails}
`;

/**
 * @deprecated use getQuestionLibraryCountQueryV2 instead
 * This is kept for backward compatibility
 * It will be removed in future versions
 */
export const getQuestionLibraryCountQuery = gql`
  query getQuestionLibraryCount(
    $orgResourceFilters: OrganizationResourceFilter
    $orgId: ID!
  ) {
    node(type: ORGANIZATION, id: $orgId) {
      ... on Organization {
        id
        organizationResourcesV2(filters: $orgResourceFilters) {
          resourceTypeBasedCount {
            totalCount
            questionStatusWiseCount {
              status
              count
            }
          }
        }
      }
    }
  }
`;
export const getQuestionBasicFiltersQuery = gql`
  query getQuestionBasicFilters(
    $id: ID!
    $curriculumProgramId: ID!
    $roles: [ORG_USER_ROLES_ENUM!]
    $genericTagsFilter: GenericTagsFilter
  ) {
    node(id: $id, type: ORGANIZATION) {
      id
      ... on Organization {
        grades(filters: { curriculumProgramIds: [$curriculumProgramId] }) {
          id
          name
        }
        subjects(filters: { curriculumProgramIds: [$curriculumProgramId] }) {
          id
          name
        }
        staff(
          filters: {
            roles: $roles
            curriculumProgramIds: [$curriculumProgramId]
            archivalState: ALL
          }
        ) {
          edges {
            node {
              ... on Staff {
                ...userIdentityBasicDetailItem
              }
            }
          }
        }
        genericTagsV2(filters: $genericTagsFilter) {
          ...genericTagDetailsItem
        }
      }
    }
  }
  ${staffFragment.userIdentityBasicDetail}
  ${associatedEntityTypesFragments.genericTagDetails}
`;

export const getQuestionTagsQuery = gql`
  query getQuestionTags($input: QuestionTagInput) {
    content {
      getQuestionTags(input: $input) {
        id
        label
        type
      }
    }
  }
`;

export const getPlannerElementSetsOfCurriculumQuery = gql`
  query getPlannerElementSetsOfCurriculum($ids: [ID!]) {
    multiNode(ids: $ids, type: SUBJECT) {
      id
      ... on Subject {
        id
        name
        associatedChildPlannerElementNodes(filters: { types: DP_SYLLABUS }) {
          id
          ...plannerElementNodeItem
        }
      }
    }
  }

  ${plannerElementNodeFragment.plannerElementNode}
`;

/**
 * @deprecated use getQuestionLibraryQuestionDetailsQueryV2 instead
 * This is kept for backward compatibility
 * It will be removed in future versions
 */
export const getQuestionLibraryQuestionDetailsQuery = gql`
  query getQuestionLibraryQuestionDetails($id: ID!) {
    node(id: $id, type: ORGANIZATION_RESOURCE) {
      id
      ... on OrganizationResource {
        ...organizationResourceQuestionItem
      }
      __typename
    }
  }
  ${organizationResourceQuestionFragment}
`;

export const getQuestionLibraryQuestionDetailsQueryV2 = gql`
  query getQuestionLibraryQuestionDetailsV2($id: ID!) {
    node(id: $id, type: QUESTION) {
      id
      ... on Question {
        ...questionDetailsV2Item
      }
    }
  }
  ${questionDetailsV2Fragment}
`;

export const getMypPlannerElementSetsQuery = gql`
  query getMypPlannerElementSetsQuery(
    $id: ID!
    $elementTypes: [PLANNER_ELEMENT_TYPE_ENUM]
  ) {
    node(id: $id, type: IB_MYP_CURRICULUM_PROGRAM) {
      id
      ... on IbMypCurriculumProgram {
        id
        plannerElementSets(elementTypes: $elementTypes) {
          nodes {
            id
            ...plannerElementNodeItemV2
          }
        }
      }
    }
  }
  ${associatedEntityTypesFragments.plannerElementNode}
`;

export const getQuestionLibraryCountQueryV2 = gql`
  query getQuestionLibraryCountV2(
    $questionFilters: OrganizationResourceQuestionItemFilters
    $orgId: ID!
  ) {
    node(type: ORGANIZATION, id: $orgId) {
      id
      ... on Organization {
        id
        questions(filters: $questionFilters) {
          count {
            totalCount
            questionStatusWiseCount {
              status
              count
            }
          }
        }
      }
    }
  }
`;

export const getQuestionLibraryFeedQueryV2 = gql`
  query getQuestionLibraryFeedV2(
    $questionFilters: OrganizationResourceQuestionItemFilters
    $first: Int
    $after: String
    $orgId: ID!
    $orderBy: ORDER_BY_ENUM
  ) {
    node(type: ORGANIZATION, id: $orgId) {
      id
      ... on Organization {
        id
        questions(
          filters: $questionFilters
          first: $first
          after: $after
          orderBy: $orderBy
        ) {
          edges {
            ...questionLibraryFeedDetailsItem
          }
          count {
            totalCount
            questionStatusWiseCount {
              status
              count
            }
          }
          pageInfo {
            hasNextPage
            endCursor
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
  }
  ${questionFragments.questionLibraryFeedDetailsV2}
`;
